import { Device } from "./device";
export function isAuviousCoreSupported() {
    return Device.isWebRTCSupported;
}
export function isCobrowseSupported() {
    return Device.isMutationObserverSupported;
}
export function isAsrSupported() {
    return Device.isWebAudioSupported;
}
export function isBackgroundSupported() {
    return Device.isWasmSupported; // && Device.isWebglSupported;
}
//# sourceMappingURL=compatible.js.map